import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

// Resolve a portfolio/media image to a displayable URL. Pass w for a resized thumbnail.
export const imgSrc = (item, w) => {
  if (!item) return "";
  if (item.image_url) return item.image_url;
  if (item.storage_path) return `${API}/files/${item.storage_path}${w ? `?w=${w}` : ""}`;
  return "";
};
